// extracted by mini-css-extract-plugin
export default {"btn-cancel":"s_M6xbh2OXnglQ9DMBBP","btn-done":"mHtZ9gw8ObBZmJt922hU"};